module.exports = __webpack_public_path__ + "e9ff853188fb05503d81512535da5e3e.otf";